export const NAV_BY_ROLE = {
  admin: [
    { key: "dashboard", label: "Dashboard", icon: "LayoutGrid", to: "/app/dashboard", group: "Overview" },
    { key: "calendar", label: "Calendar", icon: "Calendar", to: "/app/calendar", group: "Overview" },
    { key: "players", label: "Players", icon: "Users", to: "/app/players", group: "Evaluation" },
    { key: "ai-cockpit", label: "AI Cockpit", icon: "Sparkles", to: "/app/ai-cockpit", group: "Evaluation" },
    { key: "messaging", label: "Messaging", icon: "MessageSquare", to: "/app/messaging", group: "Family" },
    { key: "contracts", label: "Contracts", icon: "FileSignature", to: "/app/contracts", group: "Manage" },
    { key: "admin", label: "Admin Panel", icon: "Shield", to: "/app/admin", group: "Manage" },
  ],
  player: [
    { key: "dashboard", label: "Dashboard", icon: "LayoutGrid", to: "/app/dashboard", group: "Overview" },
    { key: "profile", label: "My Profile", icon: "User", to: "/app/me/profile", group: "Evaluation" },
    { key: "evaluation", label: "Evaluation", icon: "ClipboardList", to: "/app/me/evaluation", group: "Evaluation" },
    { key: "comparison-board", label: "Comparison Board", icon: "Users", to: "/app/me/comparison-board", group: "Evaluation" },
    { key: "interview", label: "Interview Prep", icon: "Mic", to: "/app/me/interview-prep", group: "Preparation" },
    { key: "documents", label: "Documents", icon: "FolderOpen", to: "/app/me/documents", group: "Preparation" },
    { key: "draft-plan", label: "Draft Plan", icon: "CalendarClock", to: "/app/me/draft-plan", group: "Strategy" },
    { key: "team-fits", label: "Team Fits", icon: "Target", to: "/app/me/team-fits", group: "Strategy" },
    { key: "agents", label: "Agent Eval", icon: "Briefcase", to: "/app/me/agents", group: "Strategy" },
    { key: "decisions", label: "Decisions", icon: "GitBranch", to: "/app/me/decisions", group: "Strategy" },
    { key: "reports", label: "Reports", icon: "FileText", to: "/app/me/reports", group: "Strategy" },
    { key: "messaging", label: "Messaging", icon: "MessageSquare", to: "/app/messaging", group: "Family" },
  ],
  family: [
    { key: "family", label: "Family Hub", icon: "Home", to: "/app/family", group: "Overview" },
    { key: "dashboard", label: "Dashboard", icon: "LayoutGrid", to: "/app/dashboard", group: "Overview" },
    { key: "calendar", label: "Calendar", icon: "Calendar", to: "/app/calendar", group: "Overview" },
    { key: "profile", label: "Player Profile", icon: "User", to: "/app/me/profile", group: "Evaluation" },
    { key: "evaluation", label: "Evaluation", icon: "ClipboardList", to: "/app/me/evaluation", group: "Evaluation" },
    { key: "comparison-board", label: "Comparison Board", icon: "Users", to: "/app/me/comparison-board", group: "Evaluation" },
    { key: "documents", label: "Documents", icon: "FolderOpen", to: "/app/me/documents", group: "Preparation" },
    { key: "prep", label: "Prep Workspace", icon: "Layers", to: "/app/me/prep", group: "Preparation" },
    { key: "education", label: "Education", icon: "GraduationCap", to: "/app/education", group: "Preparation" },
    { key: "draft-plan", label: "Draft Plan", icon: "CalendarClock", to: "/app/me/draft-plan", group: "Strategy" },
    { key: "team-fits", label: "Team Fits", icon: "Target", to: "/app/me/team-fits", group: "Strategy" },
    { key: "agents", label: "Agent Eval", icon: "Briefcase", to: "/app/me/agents", group: "Strategy" },
    { key: "decisions", label: "Decisions", icon: "GitBranch", to: "/app/me/decisions", group: "Strategy" },
    { key: "reports", label: "Reports", icon: "FileText", to: "/app/me/reports", group: "Strategy" },
    { key: "contracts", label: "Contract", icon: "FileSignature", to: "/app/me/contracts", group: "Family" },
    { key: "messaging", label: "Messaging", icon: "MessageSquare", to: "/app/messaging", group: "Family" },
  ],
  trainer: [
    { key: "dashboard", label: "Dashboard", icon: "LayoutGrid", to: "/app/dashboard", group: "Overview" },
    { key: "profile", label: "Player Profile", icon: "User", to: "/app/me/profile", group: "Evaluation" },
    { key: "comparison-board", label: "Comparison Board", icon: "Users", to: "/app/me/comparison-board", group: "Evaluation" },
    { key: "interview", label: "Interview Prep", icon: "Mic", to: "/app/me/interview-prep", group: "Preparation" },
    { key: "documents", label: "Documents", icon: "FolderOpen", to: "/app/me/documents", group: "Preparation" },
    { key: "draft-plan", label: "Draft Plan", icon: "CalendarClock", to: "/app/me/draft-plan", group: "Strategy" },
    { key: "messaging", label: "Messaging", icon: "MessageSquare", to: "/app/messaging", group: "Family" },
  ],
};

export function groupNav(items) {
  const out = {};
  items.forEach((it) => {
    out[it.group] = out[it.group] || [];
    out[it.group].push(it);
  });
  return out;
}
